<template>
  <el-header class="header">
    <div class="logo">
      <img src="../assets/images/logo.png" alt />
    </div>
    <el-menu
      :default-active="defaultActive"
      class="sanlin-el-menu"
      mode="horizontal"
      :router="router"
    >
      <el-menu-item index="/">HOME</el-menu-item>
      <el-submenu  index="/ourStory" title="" popper-class="submenu">
        <template slot="title">OUR STORY</template>
        <el-menu-item class="submenuItem" index="/ourStory/culture">CULTURE</el-menu-item>
        <el-menu-item class="submenuItem" index="/ourStory/introduce">INTRODUCTION</el-menu-item>
        <el-menu-item class="submenuItem" index="/ourStory/members">MEMBERS</el-menu-item>
        <el-menu-item class="submenuItem" index="/ourStory/profile">PROFILE</el-menu-item>
        <el-menu-item class="submenuItem" index="/ourStory/news">NEWS</el-menu-item>
      </el-submenu>
      <el-menu-item index="/ourProduct">OUR PRODUCTS</el-menu-item>
      <el-menu-item index="/contactUs">CONTACT US</el-menu-item>
    </el-menu>
  </el-header>

</template>

<script>
  export default {
    name: "Header",
    data() {
      return {
        router: true,
        defaultActive: this.$route.path
      };
    }
  }
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  margin: 0 auto;
  height: 108px !important;
  .logo {
    margin: auto 0;
    img {
      width: 161px;
      height: 36px;
    }
  }
  .sanlin-el-menu{
    display: flex;
    align-items: center;
    border-bottom: none !important;
    
    .el-menu-item{
      margin-left: 55px !important;
      width: 133px;
      padding: 0;
      text-align: center;
      height: 32px;
      font-size: 14px;
      line-height: 33px;
      color: #505050;
      font-weight: normal;
    }
    .el-submenu{
      margin-left: 55px !important;
    }
    .is-active{
      border: none;
      background-color: #003191;
      color: #ffffff;
      border-radius: 3px;
    }
  }
}
.submenu{
  width: 133px;
  padding: 0;
  text-align: center;
  height: 32px;
  font-size: 14px;
  line-height: 33px;
  color: #505050;
  font-weight: normal;
  .is-active{
    color: #003191 !important;
  }
}
.submenuItem{
  color: #505050 !important;
  font-size: 14px !important;
  font-weight: normal !important;
}

// .sanlin-el-menu {
//   min-width: 120px;
//   position: absolute !important;
//   top: 35px !important;
//   right: 45px !important;
// }
// ::v-deep .el-dropdown-menu {
//   min-width: 120px;
//   position: absolute !important;
//   top: 35px !important;
//   right: 45px !important;
// }

</style>